<template>
  <div class="authorization-guest-container">
    <button class="authorization-guest" @click="showWarning">
      Продолжить без авторизации
    </button>

    <QuestionDialog
        v-if="warningIsShown"
        title="Продолжить без авторизации?"
        :text="warningText"
        :buttons="warningButtons"
        @hide="warningIsShown = false"
        @action="warningAction"
    />
  </div>
</template>

<script>
import QuestionDialog from "../quest/commonPageElements/QuestionDialog.vue";

export default {
  components: {
    QuestionDialog
  },
  emits: ['authorizedSuccess'],
  props: {
    authEnabled: Boolean
  },
  data() {
    return {
      warningIsShown: false,
      warningButtons: [
        {
          text: 'Продолжить',
          id: 'continue'
        },
        {
          text: 'Отмена',
          id: 'cancel'
        }
      ]
    };
  },
  computed: {
    warningText() {
      return 'Без авторизации ваша история прохождения квестов может не сохраниться. ' +
          'За прохождение некоторых квестов мы даём бонусы, которые тоже могут быть вами утеряны. ' +
          'При наличии авторизации эти данные гарантированно сохранятся в вашем личном кабинете. ' +
          'Вы уверены, что хотите продолжить без авторизации?';
    }
  },
  methods: {
    showWarning() {
      this.warningIsShown = true;
    },
    warningAction(buttonId) {
      this.warningIsShown = false;
      if (buttonId === 'continue') {
        this.$emit('authorizedSuccess', 'guest', {guest: true});
      }
    }
  }
}
</script>

<style scoped>
  .authorization-guest-container {
    width: 100%;
  }

  .authorization-guest {
    margin: 5px 20px;
    width: calc(100% - 40px);
    height: 48px !important;
    background-color: #e8e8e8;
    border: none;
    border-radius: 4px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    color: #333333;
  }

  :deep(.fullscreen-form) {
    z-index: 4000;
  }
</style>